import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  compact?: boolean;
}
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 47,
    seconds: 34
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  if (compact) {
    return <div className="inline-flex items-center gap-1 font-bold tabular-nums" data-id="element-48">
        <span className="bg-white/10 backdrop-blur-sm px-2 py-1 rounded text-lg md:text-xl border border-white/20" data-id="element-49">
          {pad(time.hours)}
        </span>
        <span className="text-sm" data-id="element-50">:</span>
        <span className="bg-white/10 backdrop-blur-sm px-2 py-1 rounded text-lg md:text-xl border border-white/20" data-id="element-51">
          {pad(time.minutes)}
        </span>
        <span className="text-sm" data-id="element-52">:</span>
        <span className="bg-white/10 backdrop-blur-sm px-2 py-1 rounded text-lg md:text-xl border border-white/20" data-id="element-53">
          {pad(time.seconds)}
        </span>
      </div>;
  }
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-bold" data-id="element-54">
      <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20" data-id="element-55">
        {pad(time.hours)}
      </div>
      <span data-id="element-56">:</span>
      <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20" data-id="element-57">
        {pad(time.minutes)}
      </div>
      <span data-id="element-58">:</span>
      <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20" data-id="element-59">
        {pad(time.seconds)}
      </div>
    </div>;
}